var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_449_927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_449_927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.5H6.24997C6.03749 14.5 5.85937 14.428 5.71562 14.2842C5.57187 14.1404 5.5 13.9622 5.5 13.7496C5.5 13.537 5.57187 13.359 5.71562 13.2154C5.85937 13.0718 6.03749 13 6.24997 13H10.0961C10.3522 13 10.5669 13.0866 10.7401 13.2599C10.9134 13.4331 11 13.6477 11 13.9038V17.75C11 17.9625 10.9281 18.1406 10.7842 18.2843C10.6404 18.4281 10.4622 18.5 10.2496 18.5C10.037 18.5 9.85896 18.4281 9.71537 18.2843C9.57179 18.1406 9.5 17.9625 9.5 17.75V14.5ZM14.5 9.5H17.75C17.9625 9.5 18.1406 9.57191 18.2843 9.71573C18.4281 9.85953 18.5 10.0377 18.5 10.2503C18.5 10.4629 18.4281 10.641 18.2843 10.7846C18.1406 10.9282 17.9625 11 17.75 11H13.9038C13.6477 11 13.4331 10.9134 13.2599 10.7401C13.0866 10.5669 13 10.3522 13 10.0961V6.24998C13 6.03749 13.0719 5.85937 13.2157 5.71562C13.3595 5.57187 13.5377 5.5 13.7503 5.5C13.9629 5.5 14.141 5.57187 14.2846 5.71562C14.4282 5.85937 14.5 6.03749 14.5 6.24998V9.5Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrink);
export default __webpack_public_path__ + "static/media/shrink.1a6233f1130ed20f6b1061a0674f44c6.svg";
export { ForwardRef as ReactComponent };